import React, { useEffect, useState } from 'react'

import { Button, ModalBox, useModalContext } from '@fourthwall/components'

import { useDnsQuery } from '../../../../../../hooks/useDnsQuery'
import { useDeleteDomainMutation } from '../../queries/useDeleteDomainMutation'

type ConfirmDomainConnectModalProps = {
  newDomainName: string
  onConfirm: () => void
}

export const ConfirmDomainConnectModal = ({
  newDomainName,
  onConfirm,
}: ConfirmDomainConnectModalProps) => {
  const { close } = useModalContext()
  const [refetchInterval, setRefetchInterval] = useState<number | undefined>()
  const [isLoading, setIsLoading] = useState(false)
  const { dnsQuery, invalidateDnsQuery } = useDnsQuery([], {
    refetchInterval,
  })
  const dnsList = dnsQuery.data?.dnsList
  const { deleteDomainMutation } = useDeleteDomainMutation()

  const handleConfirmClick = () => {
    setIsLoading(true)
    deleteDomainMutation.mutate(undefined, {
      onSuccess: () => {
        invalidateDnsQuery()
        setRefetchInterval(1000)
      },
    })
  }

  useEffect(() => {
    if (dnsQuery.isSuccess && !dnsList) {
      setRefetchInterval(undefined)
      close()
      onConfirm()
    }
  }, [dnsQuery.isSuccess, dnsList])

  return (
    <ModalBox
      title="Connecting domain"
      size="small"
      buttons={[
        <Button label="Cancel" appearance="secondary" onClick={close} />,
        <Button
          label="Connect"
          appearance="primary"
          loading={isLoading}
          onClick={handleConfirmClick}
        />,
      ]}
      onClose={close}
    >
      <div>
        Connecting <strong>{newDomainName}</strong> will remove your current domain{' '}
        <strong>{dnsList?.domain}</strong>.
      </div>
    </ModalBox>
  )
}
